import {CES_RANGE} from './ces-range.model';

/**
 * Ce que chaque étendue vaut en crans : le premier, et combien il y en a.
 *
 * `count` compte les crans et ne désigne pas le dernier : c'est ainsi que l'API lit le `range` d'un
 * effort — onze crans de zéro à dix (cf. `ScaleNumberSettings`), comme pour une satisfaction.
 */
export const CES_RANGE_BOUNDS: Record<CES_RANGE, {start: number; count: number}> = {
    [CES_RANGE.ONE_TO_FIVE]: {start: 1, count: 5},
    [CES_RANGE.ONE_TO_SEVEN]: {start: 1, count: 7},
    [CES_RANGE.ZERO_TO_TEN]: {start: 0, count: 11},
};
